// auth.js (Firebase v12+ modular syntax)
import { auth } from "./firebase";
import {
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  updatePassword,
  confirmPasswordReset,
  deleteUser as firebaseDeleteUser,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";

// ---------------------------
// Sign Up
// ---------------------------
export const doCreateUserWithEmailAndPassword = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    await sendEmailVerification(userCredential.user);
    console.log("Verification email sent.");
    return userCredential.user;
  } catch (error) {
    console.error("Signup error:", error);
    throw error;
  }
};

// ---------------------------
// Sign In
// ---------------------------
export const doSignInWithEmailAndPassword = (email, password) =>
  signInWithEmailAndPassword(auth, email, password);

// ---------------------------
// Sign Out
// ---------------------------
export const doSignOut = () => {
  localStorage.removeItem("email");
  localStorage.removeItem("token");
  return signOut(auth);
};

// ---------------------------
// Password Reset
// ---------------------------
export const doPasswordReset = (email) =>
  sendPasswordResetEmail(auth, email);

// Password Change
export const doPasswordUpdate = (password) => {
  if (!auth.currentUser) throw new Error("No user is signed in");
  return updatePassword(auth.currentUser, password);
};

// Reset Password via email link
export const doConfirmPasswordReset = (code, newPassword) =>
  confirmPasswordReset(auth, code, newPassword);

// ---------------------------
// Delete User
// ---------------------------
export const doDeleteUser = () => {
  if (!auth.currentUser) throw new Error("No user is signed in");
  return firebaseDeleteUser(auth.currentUser);
};

// ---------------------------
// Get Current User
// ---------------------------
export const getCurrentUser = () => auth.currentUser;

export const userEmail = () => auth.currentUser?.email || null;

// ---------------------------
// Google Sign-In
// ---------------------------
export const doSignInWithGoogle = async () => {
  try {
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);

    const credential = GoogleAuthProvider.credentialFromResult(result);

    if (!credential?.idToken) {
      throw new Error("Google ID Token not found");
    }

    return {
      user: result.user,
      idToken: credential.idToken,
    };
  } catch (error) {
    console.error("Error during Google Sign In:", error);
    throw error;
  }
};
